module.exports = __webpack_public_path__ + "static/media/systole.b9ff3192.svg";